import { formatGymPrice } from '../../../utils/gymMoney';

export const durationOptions = [
  'Weekly',
  'Monthly',
  'Quarterly',
  'Half-Yearly',
  'Yearly',
  'Lifetime',
];

export function formatCurrency(amount) {
  return formatGymPrice(amount);
}
